import React, { createContext, useContext, useState, useEffect } from 'react';

const RegionContext = createContext();

export const useRegion = () => {
  const context = useContext(RegionContext);
  if (!context) {
    throw new Error('useRegion must be used within a RegionProvider');
  }
  return context;
};

export const PROVINCES = [
  { id: 'ontario', name: 'Ontario' },
  { id: 'british-columbia', name: 'British Columbia' },
  { id: 'alberta', name: 'Alberta' },
  { id: 'quebec', name: 'Quebec' }
];

export const RegionProvider = ({ children }) => {
  // Try to load from localStorage first, default to Ontario.
  const [selectedProvince, setSelectedProvince] = useState(() => {
    const saved = localStorage.getItem('skyfurniture_province');
    return saved || 'ontario';
  });
  const [selectedCity, setSelectedCity] = useState(() => localStorage.getItem('skyfurniture_city') || '');

  // Save to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('skyfurniture_province', selectedProvince);
  }, [selectedProvince]);

  useEffect(() => {
    if (selectedCity) localStorage.setItem('skyfurniture_city', selectedCity);
    else localStorage.removeItem('skyfurniture_city');
  }, [selectedCity]);

  const selectProvince = (provinceId) => {
    setSelectedProvince(provinceId);
    setSelectedCity('');
    localStorage.removeItem('skyfurniture_city');
  };

  const getCurrency = () => 'CAD';
  const getCurrencySymbol = () => 'CA$';
  const formatPrice = (priceCAD) => {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD',
      maximumFractionDigits: 0
    }).format(priceCAD);
  };

  const value = {
      selectedProvince,
      setSelectedProvince,
      selectedCity,
      setSelectedCity,
      selectProvince,
    provinces: PROVINCES,
    getCurrency,
    getCurrencySymbol,
    formatPrice
  };

  return (
    <RegionContext.Provider value={value}>
      {children}
    </RegionContext.Provider>
  );
};
